import { useSearchParams, Link } from 'react-router-dom';

const REASONS: Record<string, { title: string; body: string }> = {
  not_provisioned: {
    title: 'Account not provisioned',
    body: 'Your Microsoft account exists, but it has not been provisioned for Command Floor yet. Contact your administrator.',
  },
  oidc: {
    title: 'Sign-in failed',
    body: 'Microsoft returned an error during sign-in. Try again.',
  },
  token_exchange: {
    title: 'Sign-in failed',
    body: 'The authentication code could not be exchanged for a token. This usually clears up by trying again.',
  },
  missing_code: {
    title: 'Sign-in incomplete',
    body: 'Microsoft did not return an authorization code. Try signing in again.',
  },
  missing_claims: {
    title: 'Sign-in failed',
    body: 'The Microsoft account is missing required identity claims.',
  },
};

export function LoginErrorPage() {
  const [params] = useSearchParams();
  const reason = params.get('reason') ?? '';
  const { title, body } = REASONS[reason] ?? {
    title: 'Sign-in failed',
    body: 'An unknown error occurred during sign-in.',
  };

  return (
    <div className="flex h-full items-center justify-center px-6">
      <div className="w-full max-w-md rounded-lg border border-aurora bg-surface-panel p-8 text-center">
        <h1 className="mb-3 text-xl font-semibold text-slate-100">{title}</h1>
        <p className="mb-6 text-sm text-slate-400">{body}</p>
        <Link
          to="/login"
          className="inline-block rounded-md bg-flag-blue px-4 py-2 text-sm font-medium text-white hover:bg-blue-600"
        >
          Back to sign-in
        </Link>
      </div>
    </div>
  );
}
